import React from 'react';

function CloseIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
      <path
        fill="#757575"
        d="M5.18 5.18a1.748 1.748 0 012.473 0L14 11.526l6.347-6.344a1.749 1.749 0 112.473 2.473l-6.344 6.347 6.344 6.346a1.749 1.749 0 01-2.473 2.474L14 16.476l-6.347 6.345a1.749 1.749 0 11-2.473-2.474l6.344-6.346L5.18 7.654a1.748 1.748 0 010-2.473z"
      ></path>
    </svg>
  );
}

export default CloseIcon;
